webpackJsonp([2],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 26/01/2017.
	 */
	//js
	var Shared = __webpack_require__(115);
	var StoreShared = __webpack_require__(163);
	var LanguageManager = __webpack_require__(5);
	var utils = __webpack_require__(3);
	var StoreServices = __webpack_require__(162);
	// const CatalogTemplate = require("Sources/templates/store-catalog.template");
	var CatalogGridTemplate = __webpack_require__(394);
	var CatalogGridLibraryTemplate = __webpack_require__(393);
	var CatalogAddDialog = __webpack_require__(392);
	var Alerter = __webpack_require__(364);
	var Tooltip = __webpack_require__(134);
	
	//Styles
	__webpack_require__(653);
	
	$(function () {
	  LanguageManager.init(function () {
	    StoreShared.init();
	    catalogOverview.init();
	  }, Shared.defaultLocale);
	});
	
	var catalogOverview = {};
	
	(function (CatalogOverview) {
	  var catalog;
	  var catalogTemplate;
	  var catalogAddTemplate;
	
	  var catalogScrollPos;
	
	  CatalogOverview.init = function () {
	    var userTypeAlert = new Alerter({
	      insertAfter: $("body .page-wrapper > .header"),
	      level: "info",
	      type: "banner",
	      text: utils.format(LanguageManager.getValueForKey("store.catalog.current_user_type.alert.message"), LanguageManager.getValueForKey(getReadableUserTypeForAlert(StoreShared.getUserType())), LanguageManager.getValueForKey(getReadableLocaleForAlert(StoreShared.getUserLocale()))),
	      dismissible: true,
	      fullWidth: true
	    });
	
	    setUpTitleForUserType();
	
	    getCatalog(function () {
	      if (!utils.isNullOrEmpty(catalog.extraInfoKey)) {
	        $("#catalog-info-text").show().html(LanguageManager.getValueForKey(catalog.extraInfoKey));
	      }
	
	      catalogAddTemplate = new CatalogAddDialog({
	        title: LanguageManager.getValueForKey("store.catalog.add_dialog.title"),
	        catalog: catalog,
	        confirmBtnText: LanguageManager.getValueForKey("store.catalog.add_dialog.confirm.btn"),
	        cancelBtnText: LanguageManager.getValueForKey("store.catalog.add_dialog.cancel.btn"),
	        onConfirm: goToShoppingCart,
	        onCancel: continueShopping
	      });
	
	      setUpOverview();
	    });
	  };
	
	  function setUpTitleForUserType() {
	    var userType = StoreShared.getUserType();
	    var titleOptions = getTitleOptionsForUserType(userType);
	    titleOptions.tooltip = null;
	    var catalogTitleEl = $("#catalog-page-title");
	
	    if (StoreShared.getUserType() === "BIB") catalogTitleEl.hide();else catalogTitleEl.text(titleOptions.title);
	
	    if (utils.isNotNull(titleOptions.tooltip)) {
	      var tooltipEl = $("<button class='btn btn-icon frameless question-circle title-tooltip' type='button'></button>");
	
	      Tooltip.create({
	        selector: tooltipEl,
	        content: titleOptions.tooltip
	      });
	
	      catalogTitleEl.after(tooltipEl);
	    }
	
	    if (titleOptions.showSearch) {
	      var catalogSearchWrapper = $("#catalog-search-wrapper");
	
	      catalogSearchWrapper.show();
	
	      catalogSearchWrapper.find("input[type='text']").on("keyup", function (e) {
	        if (e.keyCode === 13) {
	          var $this = $(this);
	          var inputVal = $this.val();
	
	          if ($this.hasClass("clearable") && !$this.hasClass("clear-active") && !utils.isNullOrEmpty(inputVal)) {
	            $this.addClass("clear-active");
	          } else if ($this.hasClass("clearable") && $this.hasClass("clear-active") && utils.isNullOrEmpty(inputVal)) {
	            $this.removeClass("clear-active");
	          }
	
	          searchCatalog(inputVal);
	        }
	      });
	
	      catalogSearchWrapper.find(".btn.btn-icon").on("click", function (e) {
	        var inputEl = catalogSearchWrapper.find("input[type='text']");
	        var inputVal = inputEl.val();
	
	        if (inputEl.hasClass("clearable") && !inputEl.hasClass("clear-active") && !utils.isNullOrEmpty(inputVal)) {
	          inputEl.addClass("clear-active");
	        } else if (inputEl.hasClass("clearable") && inputEl.hasClass("clear-active") && utils.isNullOrEmpty(inputVal)) {
	          inputEl.removeClass("clear-active");
	        }
	
	        searchCatalog(inputVal);
	      });
	
	      catalogSearchWrapper.find(".reset-btn").on("click", function (e) {
	        var $this = $(this);
	
	        $this.parent().find("input.clearable[type='text']").removeClass("clear-active").val("");
	        searchCatalog();
	      });
	    }
	
	    if (titleOptions.showSort) {
	      var catalogSortWrapper = $("#catalog-sort-wrapper");
	      var catalogSortSelect = $("#catalog-sort");
	
	      catalogSortWrapper.show();
	
	      catalogSortSelect.on("change", function (e) {
	        sortCatalog($(this).val());
	      });
	    }
	  }
	
	  function getTitleOptionsForUserType(userType) {
	    switch (userType) {
	      case "SCH":
	        return { title: LanguageManager.getValueForKey("store.catalog.school.title"), tooltip: LanguageManager.getValueForKey("store.catalog.school.tooltip"), showSearch: false, showSort: false };
	      case "CON":
	        return { title: LanguageManager.getValueForKey("store.catalog.consumer.title"), tooltip: LanguageManager.getValueForKey("store.catalog.consumer.tooltip"), showSearch: true, showSort: true };
	      case "LIB":
	        return { title: LanguageManager.getValueForKey("store.catalog.library.title"), tooltip: LanguageManager.getValueForKey("store.catalog.library.tooltip"), showSearch: true, showSort: true };
	      case "LOG":
	        return { title: LanguageManager.getValueForKey("store.catalog.logopaedics.title"), tooltip: LanguageManager.getValueForKey("store.catalog.logopaedics.tooltip"), showSearch: false, showSort: false };
	      case "AND":
	        return { title: LanguageManager.getValueForKey("store.catalog.other.title"), tooltip: LanguageManager.getValueForKey("store.catalog.other.tooltip"), showSearch: false, showSort: false };
	      default:
	        return { title: LanguageManager.getValueForKey("store.catalog.title"), tooltip: null, showSearch: false, showSort: false };
	    }
	  }
	
	  function sortCatalog(sortProperty) {
	    utils.devLog("Sorting catalog on property [%s]", sortProperty);
	
	    if (utils.isNotNull(catalogTemplate)) {
	      if (utils.isNullOrEmpty(sortProperty)) {
	        catalogTemplate.reset();
	      } else {
	        catalogTemplate.sort({
	          sortKey: sortProperty,
	          sortType: "string"
	        });
	      }
	    }
	  }
	
	  function searchCatalog(keyword) {
	    utils.devLog("Filtering catalog on keyword [%s]", keyword);
	
	    if (utils.isNotNull(catalogTemplate)) {
	      var emptyCatalogTextEl = $("#empty-catalog-text").hide();
	
	      if (utils.isNullOrEmpty(keyword)) {
	        catalogTemplate.reset();
	      } else {
	        catalogTemplate.filter({
	          property: null,
	          filterValues: [keyword],
	          exact: false
	        });
	
	        if (catalogTemplate.visibleArticles === 0) {
	          emptyCatalogTextEl.show();
	        }
	      }
	    }
	  }
	
	  function setUpOverview() {
	    if (StoreShared.getUserType() !== "BIB") {
	      catalogTemplate = new CatalogGridTemplate({
	        appendTo: $("#catalog"),
	        catalog: catalog,
	        cart: StoreShared.sessionData.cart,
	        addToCart: addArticleToCart,
	        onShowDetails: showArticleDetails
	      });
	
	      if (StoreShared.getUserType() === "SCH") {
	        $("#catalog").append("<p class='catalog-remark'>" + LanguageManager.getValueForKey("store.catalog.group_purchase.not_available") + "</p>");
	      }
	    } else {
	      catalogTemplate = new CatalogGridLibraryTemplate({
	        appendTo: $("#catalog"),
	        catalog: catalog,
	        cart: StoreShared.sessionData.cart,
	        addToCart: addArticleToCart,
	        onShowDetails: showArticleDetails
	      });
	    }
	  }
	
	  function showArticleDetails(article) {
	    utils.devLog("Showing article details: %o", article);
	
	    var articleDetailsEl = $("#catalog-article-details").empty();
	
	    var articleDetailsWrapper = $("<div class='article-details'></div>");
	
	    var articleTitleEl = $("<div class='article-title-wrapper'></div>");
	    var backToCatalogBtn = $("<button class='btn btn-link title-back' type='button'>" + LanguageManager.getValueForKey("store.catalog.article_details.back") + "</button>").on("click", function (e) {
	      showCatalog();
	    });
	    articleTitleEl.append(backToCatalogBtn).append("<h3 class='page-title'>" + article.title + "</h3>");
	
	    var rightColumn = $("<div class='article-details-right'></div>");
	
	    rightColumn.append(getArticleInfoEl(article));
	
	    var leftColumn = $("<div class='article-details-left'></div>");
	    //Article image
	    leftColumn.append("<div class='article-details-image'><img src='" + article.image + "'></div>");
	    //Article price
	    leftColumn.append("<div class='article-details-price'><span class='price'>" + catalog.currency + " " + article.priceVat + "</span><span class='vat'>" + LanguageManager.getValueForKey("store.catalog.vat.inclusive") + " " + article.vatPercentage + "% " + LanguageManager.getValueForKey("store.catalog.vat") + "</span></div>");
	    //Article add to cart
	    var addToCartBtn = $("<button class='btn btn-main no-icon add-article-btn' type='button'>" + LanguageManager.getValueForKey("store.catalog.add_to_cart") + "</button>").attr("data-article-key", article.key);
	
	    if (!article.purchasable && !utils.isNullOrEmpty(article.remark)) {
	      addToCartBtn.addClass("disabled");
	
	      Tooltip.create({
	        selector: addToCartBtn,
	        content: article.remark,
	        placement: "right"
	      });
	    } else if (article.alreadyOwned) {
	      addToCartBtn.addClass("disabled");
	
	      Tooltip.create({
	        selector: addToCartBtn,
	        content: LanguageManager.getValueForKey("store.catalog.article.already_owned"),
	        placement: "right"
	      });
	    } else if (utils.isNotNull(StoreShared.sessionData.cart) && StoreShared.sessionData.cart.containsArticle(article.key) && article.purchaseOnce) {
	      addToCartBtn.addClass("disabled");
	
	      Tooltip.create({
	        selector: addToCartBtn,
	        content: LanguageManager.getValueForKey("store.catalog.article.purchase_once"),
	        placement: "right"
	      });
	    } else {
	      addToCartBtn.on("click", function (e) {
	        var $this = $(this);
	
	        if ($this.hasClass("disabled")) {
	          return;
	        }
	
	        var articleKey = $this.attr("data-article-key");
	
	        var article = catalog.getArticleForKey(articleKey);
	
	        if (utils.isNotNull(article) && !article.alreadyOwned) {
	          addArticleToCart(articleKey);
	        }
	      });
	    }
	
	    leftColumn.append(addToCartBtn);
	
	    articleDetailsWrapper.append(articleTitleEl);
	    articleDetailsWrapper.append(leftColumn);
	    articleDetailsWrapper.append(rightColumn);
	
	    articleDetailsEl.append(articleDetailsWrapper);
	
	    catalogScrollPos = $(document).scrollTop();
	    doJsPageTransition(articleDetailsEl);
	  }
	
	  function getArticleInfoEl(article) {
	    var articleInfo = $("<div class='article-details-info'></div>");
	
	    if (utils.isNotNull(article.infoKey)) {
	      var infoPartial = getInfoPartialFromKey(article.infoKey);
	      articleInfo.html(infoPartial);
	    } else {
	      if (utils.isNotNull(article.readableType)) {
	        //Article type
	        articleInfo.append("<h5 class='article-details-type'>" + LanguageManager.getValueForKey(article.readableType) + "</h5>");
	      }
	
	      if (utils.isNotNull(article.author)) {
	        //Article author
	        articleInfo.append("<div class='article-details-author'>" + article.author + "</div>");
	      }
	
	      if (utils.isNotNull(article.publisher)) {
	        //Article publisher
	        articleInfo.append("<div class='article-details-publisher'>" + article.publisher + "</div>");
	      }
	      /*
	            if(utils.isNotNull(article.themes))
	            {
	              //Article themes
	              articleInfo.append("<span class='article-themes'><span class='article-info-label'>" + LanguageManager.getValueForKey("store.catalog.article_details.labels.themes") + "</span><span class='article-info-value'>" + article.themes.join(", ") + "</span></div>");
	            }
	      */
	      if (!utils.isNullOrEmpty(article.age)) {
	        //Article age
	        articleInfo.append("<div class='article-age'>" + article.age + "</div>");
	      }
	
	      //Article description
	      articleInfo.append("<div class='article-details-description'>" + article.description + "</div>");
	    }
	
	    return articleInfo;
	  }
	
	  function getInfoPartialFromKey(key) {
	    var req = __webpack_require__(361);
	
	    try {
	      var infoPageRequire = "./" + key + ".html";
	
	      if ($.inArray(infoPageRequire, req.keys()) !== -1) {
	        return req(infoPageRequire);
	      }
	    } catch (e) {
	      console.error(e);
	    }
	
	    return null;
	  }
	
	  function showCatalog() {
	    doJsPageTransition($("#catalog"), true, function () {
	      if (utils.isNotNull(catalogScrollPos)) {
	        // $("body, html").animate({
	        //   scrollTop: catalogScrollPos
	        // }, 300);
	
	        $("body, html").scrollTop(catalogScrollPos);
	      }
	    });
	
	    // $("body, html").scrollTop(catalogScrollPos);
	
	    // $("body, html").animate({
	    //   scrollTop: catalogScrollPos
	    // }, 300);
	  }
	
	  function doJsPageTransition(toPage, reverse, callback) {
	    // $("body, html").animate({
	    //   scrollTop: 0
	    // }, 300);
	    // $("body, html").scrollTop(0);
	
	    var wrapperTopOffset = $(".tr-pages").offset().top;
	    var currentPage = $(".tr-pages .tr-page-current");
	    var currentPageAbove = currentPage.index() < toPage.index();
	
	    currentPage.removeClass("tr-page-current");
	    toPage.addClass("tr-page-current");
	    if (utils.isFunction(callback)) {
	      callback();
	    }
	    return;
	
	    // 110% instead 100% so it gives the illusion that the 2 elements aren't right next to eachother but with some margin between them
	    var currentPageTopOffset = currentPageAbove ? currentPage.offset().top - wrapperTopOffset : toPage.height() * -1,
	        currentPageLeftOffsetStart = reverse === true ? "0" : "0",
	        currentPageLeftOffsetEnd = reverse === true ? "110%" : "-110%",
	        toPageTopOffset = currentPageAbove ? currentPage.height() * -1 : 0,
	        toPageLeftOffsetStart = reverse === true ? "-110%" : "110%",
	        toPageLeftOffsetEnd = reverse === true ? "0" : "0";
	
	    currentPage.css("transform", "translate(" + currentPageLeftOffsetStart + ", " + currentPageTopOffset + "px)");
	    toPage.addClass("tr-page-current").css("transform", "translate(" + toPageLeftOffsetStart + ", " + toPageTopOffset + "px)");
	
	    // Force layout recalc
	    currentPage.css("width");
	    toPage.css("width");
	
	    currentPage.css({
	      "transform": "translate(" + currentPageLeftOffsetEnd + ", " + currentPageTopOffset + "px)",
	      "transition": "transform 600ms"
	    });
	
	    toPage.css({
	      "transform": "translate(" + toPageLeftOffsetEnd + ", " + toPageTopOffset + "px)",
	      "transition": "transform 600ms"
	    });
	
	    setTimeout(function () {
	      currentPage.removeClass("tr-page-current");
	      currentPage.css({
	        "transform": "none",
	        "transition": "none"
	      });
	
	      toPage.css({
	        "transform": "none",
	        "transition": "none"
	      });
	
	      if (utils.isFunction(callback)) {
	        callback();
	      }
	    }, 600);
	  }
	
	  function addArticleToCart(key) {
	    var article = catalog.getArticleForKey(key);
	    var cartItem = StoreShared.sessionData.cart.getItemForArticleKey(key);
	
	    if (utils.isNotNull(cartItem) && article.purchaseOnce) {
	      utils.devLog("Article is already in cart and can only be purchased once");
	      return;
	    }
	
	    if (article.purchasable) {
	      utils.devLog("Adding article with key [%s] to shopping cart", key);
	
	      var quantity = utils.isNotNull(cartItem) ? cartItem.quantity + 1 : 1;
	
	      changeArticleQuantity(key, quantity, function () {
	        $("#shopping-cart-quantity").text(StoreShared.sessionData.cart.itemCount);
	        catalogAddTemplate.cartQuantity = StoreShared.sessionData.cart.itemCount;
	        catalogAddTemplate.cartPrice = StoreShared.sessionData.catalog.currency + " " + StoreShared.sessionData.cart.totalPriceVat;
	        catalogAddTemplate.article = article;
	        catalogAddTemplate.show();
	      });
	    } else {
	      Shared.Dialog.showMessageDialog(data.readableErrorTitle, data.readableErrorMessage);
	      utils.devLog("Article with key [%s] is not purchasable.\nRemark: %s", key, article.remark);
	    }
	  }
	
	  function goToShoppingCart() {
	    utils.redirect("/store/cart");
	  }
	
	  function continueShopping() {
	    if (!$("#catalog").is(":visible")) {
	      showCatalog();
	    }
	  }
	
	  function getReadableUserTypeForAlert(userType, locale) {
	    switch (userType) {
	      case "BIB":
	        return LanguageManager.getValueForKey("store.catalog.current_user_type.library");
	      case "SCH":
	        return LanguageManager.getValueForKey("store.catalog.current_user_type.school");
	      case "CON":
	        return LanguageManager.getValueForKey("store.catalog.current_user_type.consumer");
	      case "LOG":
	        return LanguageManager.getValueForKey("store.catalog.current_user_type.logopaedic");
	      case "KND":
	        return LanguageManager.getValueForKey("store.catalog.current_user_type.knd");
	      case "PSZ":
	        return LanguageManager.getValueForKey("store.catalog.current_user_type.psz");
	      default:
	        return userType;
	    }
	  }
	
	  function getReadableLocaleForAlert(locale) {
	    switch (locale.toUpperCase()) {
	      case "NL_BE":
	        return LanguageManager.getValueForKey("store.catalog.current_user_locale.nl_BE");
	      case "NL_NL":
	        return LanguageManager.getValueForKey("store.catalog.current_user_locale.nl_NL");
	      default:
	        return locale;
	    }
	  }
	
	  function getCatalog(callback) {
	    StoreServices.getCatalog(null, function (data) {
	      // Success
	      catalog = data;
	
	      utils.devLog("Catalog: %o", catalog);
	
	      if (utils.isFunction(callback)) {
	        callback();
	      }
	    }, function (data) {
	      // Failed
	      Shared.Dialog.showMessageDialog(data.readableErrorTitle, data.readableErrorMessage);
	      console.error("Something went wrong trying to fetch catalog\ndata: %o", data);
	    });
	  }
	
	  function changeArticleQuantity(key, quantity, callback) {
	    StoreServices.setCartArticleQuantity(key, quantity, function (data) {
	      // Success
	      utils.devLog("Shopping cart after article add: %o", data);
	
	      StoreShared.sessionData = data;
	
	      if (utils.isFunction(callback)) {
	        callback(data);
	      }
	    }, function (data) {
	      // Fail
	      Shared.Dialog.showMessageDialog(data.readableErrorTitle, data.readableErrorMessage);
	      console.error("Failed to add article with key [%s] to cart\ndata: %o", key, data);
	    });
	  }
	})(catalogOverview);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 117
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 116;


/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 6,
		"./af.js": 6,
		"./ar": 12,
		"./ar-dz": 7,
		"./ar-dz.js": 7,
		"./ar-ly": 8,
		"./ar-ly.js": 8,
		"./ar-ma": 9,
		"./ar-ma.js": 9,
		"./ar-sa": 10,
		"./ar-sa.js": 10,
		"./ar-tn": 11,
		"./ar-tn.js": 11,
		"./ar.js": 12,
		"./az": 13,
		"./az.js": 13,
		"./be": 14,
		"./be.js": 14,
		"./bg": 15,
		"./bg.js": 15,
		"./bn": 16,
		"./bn.js": 16,
		"./bo": 17,
		"./bo.js": 17,
		"./br": 18,
		"./br.js": 18,
		"./bs": 19,
		"./bs.js": 19,
		"./ca": 20,
		"./ca.js": 20,
		"./cs": 21,
		"./cs.js": 21,
		"./cv": 22,
		"./cv.js": 22,
		"./cy": 23,
		"./cy.js": 23,
		"./da": 24,
		"./da.js": 24,
		"./de": 26,
		"./de-at": 25,
		"./de-at.js": 25,
		"./de.js": 26,
		"./dv": 27,
		"./dv.js": 27,
		"./el": 28,
		"./el.js": 28,
		"./en-au": 29,
		"./en-au.js": 29,
		"./en-ca": 30,
		"./en-ca.js": 30,
		"./en-gb": 31,
		"./en-gb.js": 31,
		"./en-ie": 32,
		"./en-ie.js": 32,
		"./en-nz": 33,
		"./en-nz.js": 33,
		"./eo": 34,
		"./eo.js": 34,
		"./es": 36,
		"./es-do": 35,
		"./es-do.js": 35,
		"./es.js": 36,
		"./et": 37,
		"./et.js": 37,
		"./eu": 38,
		"./eu.js": 38,
		"./fa": 39,
		"./fa.js": 39,
		"./fi": 40,
		"./fi.js": 40,
		"./fo": 41,
		"./fo.js": 41,
		"./fr": 44,
		"./fr-ca": 42,
		"./fr-ca.js": 42,
		"./fr-ch": 43,
		"./fr-ch.js": 43,
		"./fr.js": 44,
		"./fy": 45,
		"./fy.js": 45,
		"./gd": 46,
		"./gd.js": 46,
		"./gl": 47,
		"./gl.js": 47,
		"./he": 48,
		"./he.js": 48,
		"./hi": 49,
		"./hi.js": 49,
		"./hr": 50,
		"./hr.js": 50,
		"./hu": 51,
		"./hu.js": 51,
		"./hy-am": 52,
		"./hy-am.js": 52,
		"./id": 53,
		"./id.js": 53,
		"./is": 54,
		"./is.js": 54,
		"./it": 55,
		"./it.js": 55,
		"./ja": 56,
		"./ja.js": 56,
		"./jv": 57,
		"./jv.js": 57,
		"./ka": 58,
		"./ka.js": 58,
		"./kk": 59,
		"./kk.js": 59,
		"./km": 60,
		"./km.js": 60,
		"./ko": 61,
		"./ko.js": 61,
		"./ky": 62,
		"./ky.js": 62,
		"./lb": 63,
		"./lb.js": 63,
		"./lo": 64,
		"./lo.js": 64,
		"./lt": 65,
		"./lt.js": 65,
		"./lv": 66,
		"./lv.js": 66,
		"./me": 67,
		"./me.js": 67,
		"./mi": 68,
		"./mi.js": 68,
		"./mk": 69,
		"./mk.js": 69,
		"./ml": 70,
		"./ml.js": 70,
		"./mr": 71,
		"./mr.js": 71,
		"./ms": 73,
		"./ms-my": 72,
		"./ms-my.js": 72,
		"./ms.js": 73,
		"./my": 74,
		"./my.js": 74,
		"./nb": 75,
		"./nb.js": 75,
		"./ne": 76,
		"./ne.js": 76,
		"./nl": 78,
		"./nl-be": 77,
		"./nl-be.js": 77,
		"./nl.js": 78,
		"./nn": 79,
		"./nn.js": 79,
		"./pa-in": 80,
		"./pa-in.js": 80,
		"./pl": 81,
		"./pl.js": 81,
		"./pt": 83,
		"./pt-br": 82,
		"./pt-br.js": 82,
		"./pt.js": 83,
		"./ro": 84,
		"./ro.js": 84,
		"./ru": 85,
		"./ru.js": 85,
		"./se": 86,
		"./se.js": 86,
		"./si": 87,
		"./si.js": 87,
		"./sk": 88,
		"./sk.js": 88,
		"./sl": 89,
		"./sl.js": 89,
		"./sq": 90,
		"./sq.js": 90,
		"./sr": 92,
		"./sr-cyrl": 91,
		"./sr-cyrl.js": 91,
		"./sr.js": 92,
		"./ss": 93,
		"./ss.js": 93,
		"./sv": 94,
		"./sv.js": 94,
		"./sw": 95,
		"./sw.js": 95,
		"./ta": 96,
		"./ta.js": 96,
		"./te": 97,
		"./te.js": 97,
		"./tet": 98,
		"./tet.js": 98,
		"./th": 99,
		"./th.js": 99,
		"./tl-ph": 100,
		"./tl-ph.js": 100,
		"./tlh": 101,
		"./tlh.js": 101,
		"./tr": 102,
		"./tr.js": 102,
		"./tzl": 103,
		"./tzl.js": 103,
		"./tzm": 105,
		"./tzm-latn": 104,
		"./tzm-latn.js": 104,
		"./tzm.js": 105,
		"./uk": 106,
		"./uk.js": 106,
		"./uz": 107,
		"./uz.js": 107,
		"./vi": 108,
		"./vi.js": 108,
		"./x-pseudo": 109,
		"./x-pseudo.js": 109,
		"./yo": 110,
		"./yo.js": 110,
		"./zh-cn": 111,
		"./zh-cn.js": 111,
		"./zh-hk": 112,
		"./zh-hk.js": 112,
		"./zh-tw": 113,
		"./zh-tw.js": 113
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 120;


/***/ }),

/***/ 321:
259,

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./bibnet_subscription_avi.html": 671,
		"./bibnet_subscription_pb.html": 672,
		"./log_subscription_avi.html": 673,
		"./log_subscription_pb.html": 674,
		"./psz_subscription_pb.html": 675,
		"./sch_be_subscription_avi.html": 676,
		"./sch_be_subscription_pb.html": 677
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 361;


/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 16/02/2017.
	 */
	var utils = __webpack_require__(3);
	var Dialog = __webpack_require__(183);
	
	__webpack_require__(609);
	
	module.exports = function () {
	  function Alerter(options) {
	    _classCallCheck(this, Alerter);
	
	    /*
	        __          _______ _____
	       \ \        / /_   _|  __ \
	        \ \  /\  / /  | | | |__) |
	         \ \/  \/ /   | | |  ___/
	          \  /\  /   _| |_| |
	           \/  \/   |_____|_|
	      * type (dialog | banner | notification | ... )
	     * level (info | warning | error)
	     *
	     * title (for type dialog [required] and banner [not required])
	     * text
	     *
	     * dismissible (for type dialog and banner)
	     * dismissWait (time before alert disappears, 0 for never)
	     */
	
	    if (utils.isNull(options) && utils.isObject(options)) {
	      throw "options must be defined";
	    }
	
	    this.type = options.type;
	    this.level = utils.isNullOrEmpty(options.level) ? "info" : options.level;
	
	    this.appendTo = options.appendTo;
	    this.insertAfter = options.insertAfter;
	    // this.prependTo = utils.isNotNull(options.appendTo) ? options.appendTo : $("body .page-wrapper > .container");
	    this.prependTo = options.appendTo;
	
	    this.title = options.title;
	    this.text = options.text;
	
	    this.dismissible = utils.isBoolean(options.dismissible) ? options.dismissible : true;
	    this.dismissWait = utils.isNumber(options.dismissWait) ? options.dismissWait : 0; // time it takes before auto dismiss (0 for don't auto dismiss (default))
	
	    this.fullWidth = utils.isBoolean(options.fullWidth) ? options.fullWidth : false;
	
	    this.alertEl = null;
	
	    this.onDismiss = options.onDismiss;
	
	    this.createAlertEl();
	  }
	
	  _createClass(Alerter, [{
	    key: "createAlertEl",
	    value: function createAlertEl() {
	      if (this._initialized !== true) {
	        switch (this.type) {
	          case "dialog":
	            this.createAlertDialog();
	            break;
	          case "banner":
	            this.createAlertBanner();
	            break;
	          default:
	            throw "Invalid alert type";
	        }
	      }
	    }
	  }, {
	    key: "createAlertDialog",
	    value: function createAlertDialog() {
	      throw "NYI";
	
	      if (this._initialized !== true && this.type === "dialog") {
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "createAlertBanner",
	    value: function createAlertBanner() {
	      if (this._initialized !== true && this.type === "banner") {
	        this.alertEl = $("<div class='alert alert-banner'></div>").addClass(this.level);
	
	        var alertWrapper = $("<div class='alert-wrapper'></div>");
	
	        if (this.fullWidth) {
	          alertWrapper.addClass("full-width");
	        }
	
	        alertWrapper.append("<div class='alert-content'>" + this.text + "</div>");
	
	        if (this.dismissible) {
	          var that = this;
	          var closeBtn = $("<button class='btn btn-icon frameless cross-circle white alert-dismiss' type='button'></button>");
	          closeBtn.on("click", function (e) {
	            that.dismiss();
	          });
	          alertWrapper.append(closeBtn);
	        }
	
	        this.alertEl.append(alertWrapper);
	
	        if (utils.isNotNull(this.appendTo)) {
	          this.appendTo.append(this.alertEl);
	        } else if (utils.isNotNull(this.prependTo)) {
	          this.prependTo.prepend(this.alertEl);
	        } else if (utils.isNotNull(this.insertAfter)) {
	          this.alertEl.insertAfter(this.insertAfter);
	        }
	
	        this.show();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.alertEl.show();
	
	      if (this.dismissWait > 0) {
	        var that = this;
	
	        setTimeout(function () {
	          that.dismiss();
	        }, that.dismissWait);
	      }
	    }
	  }, {
	    key: "dismiss",
	    value: function dismiss() {
	      if (utils.isNotNull(this.alertEl)) {
	        this.alertEl.remove();
	      }
	
	      if (utils.isFunction(this.onDismiss)) {
	        this.onDismiss();
	      }
	    }
	  }]);
	
	  return Alerter;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 29/03/2017.
	 */
	var utils = __webpack_require__(3);
	var LanguageManager = __webpack_require__(5);
	
	__webpack_require__(610);
	
	module.exports = function () {
	  function CartTemplate(options) {
	    _classCallCheck(this, CartTemplate);
	
	    /*
	     * options.appendTo
	     * options.cart (Cart object [models/store/cart.js])
	     *
	     * options.setItemQuantity(key, quantity)
	     */
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.dialogId = utils.isNullOrEmpty(options.dialogId) ? "catalog-add-dialog-" + utils.generateUIDShort() : options.dialogId;
	    this.backdropIdSuffix = "-modal-backdrop";
	
	    this.title = options.title;
	
	    this.cartQuantity = utils.isNotNull(options.cartQuantity) ? options.cartQuantity : 0;
	    this.cartPrice = utils.isNotNull(options.cartPrice) ? options.cartPrice : 0;
	
	    this.catalog = options.catalog;
	    this._article = options.article;
	
	    this.confirmBtnText = options.confirmBtnText;
	    this.cancelBtnText = options.cancelBtnText;
	
	    this.onConfirm = options.onConfirm;
	    this.onCancel = options.onCancel;
	
	    this.create();
	  }
	
	  _createClass(CartTemplate, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.dialogEl = $("<div id='" + this.dialogId + "' class='modal catalog-add-dialog fade'>" + "<div class='modal-dialog'>" + "<div class='modal-content clearfix'>" + "</div>" + "</div>" + "</div>");
	        this.dialogContentEl = this.dialogEl.find(".modal-content");
	
	        this.backdrop = "<div id='" + this.backdropId + "' class='modal-backdrop fade'></div>";
	
	        this.refresh();
	
	        $("body").append(this.dialogEl);
	        this.addDisposeListener();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "refresh",
	    value: function refresh() {
	      this.dialogContentEl.empty();
	
	      this.renderTitle();
	      this.renderArticle();
	      this.renderCartQuantity();
	      this.renderButtonGroup();
	    }
	  }, {
	    key: "renderTitle",
	    value: function renderTitle() {
	      if (!utils.isNullOrEmpty(this.title)) {
	        this.dialogContentEl.append("<h3 class='dialog-title'>" + this.title + "</h3>");
	      }
	    }
	  }, {
	    key: "renderArticle",
	    value: function renderArticle() {
	      if (utils.isNotNull(this.article)) {
	        var articleWrapper = $("<div class='article-wrapper clearfix'></div>");
	
	        var title = utils.isNullOrEmpty(this.article.title) ? "" : this.article.title;
	        var author = utils.isNullOrEmpty(this.article.author) ? "" : this.article.author;
	        var publisher = utils.isNullOrEmpty(this.article.publisher) ? "" : this.article.publisher;
	
	        articleWrapper.append("<div class='article-image'><img src='" + this.article.image + "'/></div>");
	        articleWrapper.append("<div class='article-info-wrapper'>" + "<div class='article-info'>" + "<div class='article-title'>" + title + "</div>" + "<div class='article-author'>" + author + "</div>" + "<div class='article-publisher'>" + publisher + "</div>" + "</div>" + "<div class='align-bottom'>" + "<div class='article-price'>" + "<div class='price'>" + this.catalog.currency + " " + this.article.priceVat + "</div>" + "<div class='vat'>" + LanguageManager.getValueForKey("store.catalog.vat.inclusive") + " " + this.article.vatPercentage + "% " + LanguageManager.getValueForKey("store.catalog.vat") + "</div>" + "</div>" + "</div>" + "</div>");
	
	        this.dialogContentEl.append(articleWrapper);
	      }
	    }
	  }, {
	    key: "renderCartQuantity",
	    value: function renderCartQuantity() {
	      var text = utils.format(LanguageManager.getValueForKey("store.catalog.add_dialog.cart_quantity"), this.cartQuantity, this.cartPrice);
	      this.dialogContentEl.append("<div class='cart-quantity'>" + text + "</div>");
	    }
	  }, {
	    key: "renderButtonGroup",
	    value: function renderButtonGroup() {
	      var that = this;
	      var buttonGroupEl = $("<div class='button-group'></div>");
	
	      var confirmBtn = $("<button class='btn btn-main no-icon confirm-btn' type='button'>" + that.confirmBtnText + "</button>");
	      var cancelBtn = $("<button class='btn btn-main no-icon cancel-btn' type='button'>" + that.cancelBtnText + "</button>");
	
	      confirmBtn.on("click", function (e) {
	        if (utils.isFunction(that.onConfirm)) {
	          that.onConfirm();
	        }
	      });
	
	      cancelBtn.on("click", function (e) {
	        if (utils.isFunction(that.onCancel)) {
	          that.hide();
	          that.onCancel();
	        }
	      });
	
	      buttonGroupEl.append(confirmBtn);
	      buttonGroupEl.append(cancelBtn);
	
	      this.dialogContentEl.append(buttonGroupEl);
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      this.hide();
	
	      if (utils.isNotNull(this.dialogEl) && this.dialogEl.length) {
	        this.dialogEl.remove();
	      }
	
	      this._initialized = false;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      var $body = $("body");
	      if (!$body.hasClass("modal-open")) {
	        $body.addClass("modal-open");
	      }
	
	      if (!this.backdropExists) {
	        $body.append(this.backdrop);
	        $("#" + this.backdropId).addClass("in");
	      }
	
	      // Reading a css property forces layout to be (re)computed
	      this.dialogEl.css("display", "block");
	      this.dialogEl.css("width");
	      this.dialogEl.addClass("in");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      var that = this;
	      var $body = $("body");
	      if ($body.hasClass("modal-open")) {
	        $body.removeClass("modal-open");
	      }
	
	      $("#" + that.backdropId).remove();
	
	      that.dialogEl.removeClass("in");
	
	      setTimeout(function () {
	        that.dialogEl.hide();
	      }, 150);
	    }
	  }, {
	    key: "cancel",
	    value: function cancel() {
	      this.hide();
	
	      if (utils.isFunction(this.onCancel)) {
	        this.onCancel();
	      }
	    }
	  }, {
	    key: "addDisposeListener",
	    value: function addDisposeListener() {
	      var that = this;
	
	      that.dialogEl.off().on("click", function (e) {
	        if (e.target.className === "modal-content" || $(e.target).closest(".modal-content").length) {
	          e.stopPropagation();
	          return;
	        }
	
	        that.cancel();
	      });
	    }
	  }, {
	    key: "backdropId",
	    get: function get() {
	      return this.dialogId + this.backdropIdSuffix;
	    }
	  }, {
	    key: "backdropExists",
	    get: function get() {
	      return $("#" + this.backdropId).length;
	    }
	  }, {
	    key: "article",
	    get: function get() {
	      return this._article;
	    },
	    set: function set(article) {
	      this._article = article;
	      this.refresh();
	    }
	  }]);
	
	  return CartTemplate;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 15/03/2017.
	 */
	/**
	 * Created by jv on 26/01/2017.
	 */
	var utils = __webpack_require__(3);
	var LanguageManager = __webpack_require__(5);
	var ElementCreator = __webpack_require__(131);
	var DataFilter = __webpack_require__(225);
	var Tooltip = __webpack_require__(134);
	
	__webpack_require__(321);
	
	module.exports = function () {
	  function CatalogTemplate(options) {
	    _classCallCheck(this, CatalogTemplate);
	
	    /*
	     * options.appendTo
	     * options.catalog (Catalog object [models/store/catalog.js])
	     *
	     * options.addToCart(key)
	     */
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.appendTo = $(options.appendTo);
	    this.catalog = options.catalog;
	    this.cart = options.cart;
	
	    this._filteredArticles = this.catalog.articles.slice(0);
	
	    this.addToCart = options.addToCart;
	    this.onShowDetails = options.onShowDetails;
	
	    this.create();
	  }
	
	  _createClass(CatalogTemplate, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.catalogWrapperEl = $("<div class='catalog-grid-wrapper'></div>");
	        this.appendTo.append(this.catalogWrapperEl);
	
	        this.renderCatalog();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "refresh",
	    value: function refresh() {
	      this.renderCatalog();
	    }
	  }, {
	    key: "reload",
	    value: function reload(catalog) {
	      this.catalog = catalog;
	      this.refresh();
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      this._filteredArticles = this.catalog.articles.slice(0);
	      this.refresh();
	    }
	  }, {
	    key: "sort",
	    value: function sort(options) {
	      options.sortType = utils.isNull(options.sortType) ? "" : options.sortType;
	      options.asc = utils.isBoolean(options.asc) ? options.asc : false;
	
	      this._filteredArticles = DataFilter.sort(this.catalog.articles, options.sortType, options.sortKey, options.asc);
	      this.refresh();
	    }
	  }, {
	    key: "filter",
	    value: function filter(options) {
	      /*
	       * options.property = null
	       * options.filterValues = []
	       * options.exact = false
	       * options.propertyType = "undefined"
	       */
	
	      options = utils.isNotNull(options) ? options : {};
	      options.property = utils.isUndefined(options.property) ? null : options.property;
	      options.filterValues = utils.isArray(options.filterValues) ? options.filterValues : [];
	      options.exact = utils.isBoolean(options.exact) ? options.exact : false;
	
	      this._filteredArticles = DataFilter.filter(this.catalog.articles, options.property, options.filterValues, options.exact, options.propertyType);
	      this.refresh();
	    }
	  }, {
	    key: "isSameType",
	    value: function isSameType(type1, type2) {
	      if (type1 === "license_bibnet_picturebooks" && type2 === "license_bibnet_avi") return true;
	
	      return type1 === type2;
	    }
	  }, {
	    key: "getTypeLocalization",
	    value: function getTypeLocalization(type) {
	      if (type === "license_bibnet_picturebooks" || type === "license_bibnet_avi") return LanguageManager.getValueForKey("store.catalog.article.type.subscription");
	
	      return LanguageManager.getValueForKey("store.catalog.article.type." + type);
	    }
	  }, {
	    key: "renderCatalog",
	    value: function renderCatalog() {
	      this.catalogWrapperEl.empty();
	
	      var currentType = null;
	
	      for (var i = 0; i < this._filteredArticles.length; i++) {
	        if (!this.isSameType(currentType, this._filteredArticles[i].type)) {
	          currentType = this._filteredArticles[i].type;
	          this.catalogWrapperEl.append($("<div class='catalog-sub-title'>" + this.getTypeLocalization(currentType) + "</div>"));
	        }
	
	        this.catalogWrapperEl.append(this.renderCatalogItem(this._filteredArticles[i]));
	      }
	
	      for (var j = 0; j < this._filteredArticles.length; j++) {
	        var article = this._filteredArticles[j];
	        if (!article.purchasable && !utils.isNullOrEmpty(article.remark)) {
	          Tooltip.create({
	            selector: this.catalogWrapperEl.find(".catalog-article[data-catalog-article='" + article.key + "']").find(".article-add .add-article-btn"),
	            content: article.remark,
	            placement: "auto"
	          });
	        } else if (article.alreadyOwned) {
	          Tooltip.create({
	            selector: this.catalogWrapperEl.find(".catalog-article[data-catalog-article='" + article.key + "']").find(".article-add .add-article-btn"),
	            content: LanguageManager.getValueForKey("store.catalog.article.already_owned"),
	            placement: "auto"
	          });
	        } else if (this.cart.containsArticle(article.key) && article.purchaseOnce) {
	          Tooltip.create({
	            selector: this.catalogWrapperEl.find(".catalog-article[data-catalog-article='" + article.key + "']").find(".article-add .add-article-btn"),
	            content: LanguageManager.getValueForKey("store.catalog.article.purchase_once"),
	            placement: "auto"
	          });
	        }
	      }
	
	      this.setUpEventListeners();
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var that = this;
	
	      that.catalogWrapperEl.find(".catalog-article .article-add .add-article-btn").not(".disabled").off("click").on("click", function (e) {
	        var $this = $(this);
	        var articleKey = $(this).closest(".catalog-article").attr("data-catalog-article");
	
	        var article = that.catalog.getArticleForKey(articleKey);
	
	        if (utils.isNotNull(article) && !article.alreadyOwned) {
	          if (article.purchaseOnce) {
	            $this.addClass("disabled").off();
	
	            Tooltip.create({
	              selector: $this,
	              content: LanguageManager.getValueForKey("store.catalog.article.purchase_once"),
	              placement: "auto"
	            });
	          }
	
	          if (utils.isFunction(that.addToCart)) {
	            that.addToCart(articleKey);
	          }
	        }
	      });
	
	      that.catalogWrapperEl.find(".catalog-article .article-image img, .catalog-article .article-title").off("click").on("click", function (e) {
	        var articleKey = $(this).closest(".catalog-article").attr("data-catalog-article");
	
	        var article = that.catalog.getArticleForKey(articleKey);
	
	        if (article.type !== "free_download") {
	          if (utils.isFunction(that.onShowDetails)) {
	            that.onShowDetails(article);
	          }
	        }
	      });
	    }
	  }, {
	    key: "renderCatalogItem",
	    value: function renderCatalogItem(article) {
	      var articleEl = $("<div class='catalog-article' data-catalog-article='" + article.key + "'></div>");
	
	      articleEl.append(this.createArticleImage(article));
	
	      var infoWrapper = $("<div class='article-info-wrapper'></div>").append(this.createArticleInfo(article));
	      //var alignBottom = $("<div class='align-bottom'></div>").append(this.createArticlePrice(article)).append(this.createArticleAddToCart(article));
	      var alignBottom = $("<div class='align-bottom'></div>");
	
	      if (article.type !== "free_download") {
	        alignBottom.append(this.createArticlePrice(article));
	        alignBottom.append(this.createArticleAddToCart(article));
	      } else {
	        alignBottom.append(this.createArticleDownload(article));
	      }
	
	      infoWrapper.append(alignBottom);
	      articleEl.append(infoWrapper);
	
	      return articleEl;
	    }
	  }, {
	    key: "createArticleImage",
	    value: function createArticleImage(article) {
	      var articleImage = ElementCreator.createStringElement({
	        tagName: "img",
	        attributes: [{ name: "src", value: article.image }]
	      });
	
	      var articleImageWrapper = ElementCreator.createStringElement({
	        classNames: ["article-image"],
	        innerHTML: articleImage
	      });
	
	      return articleImageWrapper;
	    }
	  }, {
	    key: "createArticleInfo",
	    value: function createArticleInfo(article) {
	      var infoEl = $("<div class='article-info'></div>");
	
	      if (!utils.isNullOrEmpty(article.title)) {
	        infoEl.append("<div class='article-title'>" + article.title + "</div>");
	      }
	
	      if (!utils.isNullOrEmpty(article.author)) {
	        infoEl.append("<div class='article-author'>" + article.author + "</div>");
	      }
	
	      if (!utils.isNullOrEmpty(article.publisher)) {
	        infoEl.append("<div class='article-publisher'>" + article.publisher + "</div>");
	      }
	
	      if (!utils.isNullOrEmpty(article.age)) {
	        infoEl.append("<div class='article-age'>" + article.age + "</div>");
	      }
	
	      if (!utils.isNullOrEmpty(article.remark)) {
	        if (article.purchasable) {
	          infoEl.append("<div class='article-remark-purchasable'>" + article.remark + "</div>");
	        }
	        /*
	        else
	        {
	          infoEl.append("<div class='article-remark-unpurchasable'>" + article.remark + "</div>");
	        }*/
	      }
	
	      // if(!utils.isNullOrEmpty(article.age))
	      // {
	      //   infoEl.append("<div class='article-age'>" + article.age + "</div>");
	      // }
	
	      return infoEl;
	    }
	  }, {
	    key: "createArticlePrice",
	    value: function createArticlePrice(article) {
	      var priceEl = ElementCreator.createStringElement({
	        classNames: ["price"],
	        innerHTML: this.catalog.currency + " " + article.priceVat
	      });
	
	      var priceExtraEl = ElementCreator.createStringElement({
	        classNames: ["vat"],
	        innerHTML: LanguageManager.getValueForKey("store.catalog.vat.inclusive") + " " + article.vatPercentage + "% " + LanguageManager.getValueForKey("store.catalog.vat")
	      });
	
	      var priceWrapperEl = ElementCreator.createStringElement({
	        classNames: ["article-price"],
	        innerHTML: priceEl + priceExtraEl
	      });
	
	      return priceWrapperEl;
	    }
	  }, {
	    key: "createArticleMoreInfo",
	    value: function createArticleMoreInfo(article) {
	      var moreInfoEl = ElementCreator.createStringElement({});
	
	      return "";
	    }
	  }, {
	    key: "createArticleAddToCart",
	    value: function createArticleAddToCart(article) {
	      var disabledClass = "";
	
	      if (!article.purchasable || article.alreadyOwned || utils.isNotNull(this.cart) && this.cart.containsArticle(article.key) && article.purchaseOnce) {
	        disabledClass = "disabled";
	      }
	
	      var addToCartLinkEl = ElementCreator.createStringElement({
	        tagName: "button",
	        classNames: ["btn", "btn-main", "no-icon", "add-article-btn", disabledClass],
	        attributes: [{ name: "data-article-key", value: article.key }, { name: "type", value: "button" }],
	        innerHTML: LanguageManager.getValueForKey("store.catalog.add_to_cart")
	      });
	
	      var addToCartWrapperEl = ElementCreator.createStringElement({
	        classNames: ["article-add"],
	        innerHTML: addToCartLinkEl
	      });
	
	      return addToCartWrapperEl;
	    }
	  }, {
	    key: "createArticleDownload",
	    value: function createArticleDownload(article) {
	      var downloadLinkEl = ElementCreator.createStringElement({
	        tagName: "button",
	        classNames: ["btn", "btn-main", "no-icon", "download-article-btn"],
	        attributes: [{ name: "data-article-key", value: article.key }, { name: "type", value: "button" }],
	        innerHTML: LanguageManager.getValueForKey("store.catalog.download")
	      });
	
	      var wrapperEl = ElementCreator.createStringElement({
	        tagName: "a",
	        classNames: ["article-download"],
	        attributes: [{ name: "href", value: article.download }, { name: "target", value: "_blank" }],
	        innerHTML: downloadLinkEl
	      });
	
	      return wrapperEl;
	    }
	  }, {
	    key: "visibleArticles",
	    get: function get() {
	      return utils.isArray(this._filteredArticles) ? this._filteredArticles.length : 0;
	    }
	  }]);
	
	  return CatalogTemplate;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 15/03/2017.
	 */
	/**
	 * Created by jv on 26/01/2017.
	 */
	var utils = __webpack_require__(3);
	var LanguageManager = __webpack_require__(5);
	var ElementCreator = __webpack_require__(131);
	var DataFilter = __webpack_require__(225);
	var Tooltip = __webpack_require__(134);
	
	__webpack_require__(321);
	
	module.exports = function () {
	  function CatalogTemplate(options) {
	    _classCallCheck(this, CatalogTemplate);
	
	    /*
	     * options.appendTo
	     * options.catalog (Catalog object [models/store/catalog.js])
	     *
	     * options.addToCart(key)
	     */
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.appendTo = $(options.appendTo);
	    this.catalog = options.catalog;
	    this.cart = options.cart;
	
	    this._filteredArticles = this.catalog.articles.slice(0);
	
	    this.addToCart = options.addToCart;
	    this.onShowDetails = options.onShowDetails;
	
	    this.create();
	  }
	
	  _createClass(CatalogTemplate, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.catalogWrapperEl = $("<div class='catalog-grid-wrapper'></div>");
	        this.appendTo.append(this.catalogWrapperEl);
	
	        this.renderCatalog();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "refresh",
	    value: function refresh() {
	      this.renderCatalog();
	    }
	  }, {
	    key: "reload",
	    value: function reload(catalog) {
	      this.catalog = catalog;
	      this.refresh();
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      this._filteredArticles = this.catalog.articles.slice(0);
	      this.refresh();
	    }
	  }, {
	    key: "sort",
	    value: function sort(options) {
	      options.sortType = utils.isNull(options.sortType) ? "" : options.sortType;
	      options.asc = utils.isBoolean(options.asc) ? options.asc : false;
	
	      this._filteredArticles = DataFilter.sort(this.catalog.articles, options.sortType, options.sortKey, options.asc);
	      this.refresh();
	    }
	  }, {
	    key: "filter",
	    value: function filter(options) {
	      /*
	       * options.property = null
	       * options.filterValues = []
	       * options.exact = false
	       * options.propertyType = "undefined"
	       */
	
	      options = utils.isNotNull(options) ? options : {};
	      options.property = utils.isUndefined(options.property) ? null : options.property;
	      options.filterValues = utils.isArray(options.filterValues) ? options.filterValues : [];
	      options.exact = utils.isBoolean(options.exact) ? options.exact : false;
	
	      this._filteredArticles = DataFilter.filter(this.catalog.articles, options.property, options.filterValues, options.exact, options.propertyType);
	      this.refresh();
	    }
	  }, {
	    key: "renderCatalog",
	    value: function renderCatalog() {
	      this.catalogWrapperEl.empty();
	
	      for (var i = 0; i < this._filteredArticles.length; i++) {
	        this.catalogWrapperEl.append(this.renderCatalogItem(this._filteredArticles[i]));
	      }
	
	      for (var j = 0; j < this._filteredArticles.length; j++) {
	        var article = this._filteredArticles[j];
	        if (!article.purchasable && !utils.isNullOrEmpty(article.remark)) {
	          Tooltip.create({
	            selector: this.catalogWrapperEl.find(".catalog-article[data-catalog-article='" + article.key + "']").find(".article-add .add-article-btn"),
	            content: article.remark,
	            placement: "auto"
	          });
	        } else if (article.alreadyOwned) {
	          Tooltip.create({
	            selector: this.catalogWrapperEl.find(".catalog-article[data-catalog-article='" + article.key + "']").find(".article-add .add-article-btn"),
	            content: LanguageManager.getValueForKey("store.catalog.article.already_owned"),
	            placement: "auto"
	          });
	        } else if (this.cart.containsArticle(article.key) && article.purchaseOnce) {
	          Tooltip.create({
	            selector: this.catalogWrapperEl.find(".catalog-article[data-catalog-article='" + article.key + "']").find(".article-add .add-article-btn"),
	            content: LanguageManager.getValueForKey("store.catalog.article.purchase_once"),
	            placement: "auto"
	          });
	        }
	      }
	
	      this.setUpEventListeners();
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var that = this;
	
	      that.catalogWrapperEl.find(".catalog-article .article-add .add-article-btn").not(".disabled").off("click").on("click", function (e) {
	        var $this = $(this);
	        var articleKey = $(this).closest(".catalog-article").attr("data-catalog-article");
	
	        var article = that.catalog.getArticleForKey(articleKey);
	
	        if (utils.isNotNull(article) && !article.alreadyOwned) {
	          if (article.purchaseOnce) {
	            $this.addClass("disabled").off();
	
	            Tooltip.create({
	              selector: $this,
	              content: LanguageManager.getValueForKey("store.catalog.article.purchase_once"),
	              placement: "auto"
	            });
	          }
	
	          if (utils.isFunction(that.addToCart)) {
	            that.addToCart(articleKey);
	          }
	        }
	      });
	
	      that.catalogWrapperEl.find(".catalog-article .article-image img, .catalog-article .article-title").off("click").on("click", function (e) {
	        var articleKey = $(this).closest(".catalog-article").attr("data-catalog-article");
	
	        var article = that.catalog.getArticleForKey(articleKey);
	
	        if (utils.isFunction(that.onShowDetails)) {
	          that.onShowDetails(article);
	        }
	      });
	    }
	  }, {
	    key: "renderCatalogItem",
	    value: function renderCatalogItem(article) {
	      var articleEl = $("<div class='catalog-article' data-catalog-article='" + article.key + "'></div>");
	
	      articleEl.append(this.createArticleImage(article));
	
	      var infoWrapper = $("<div class='article-info-wrapper'></div>").append(this.createArticleInfo(article));
	      var alignBottom = $("<div class='align-bottom'></div>").append(this.createArticlePrice(article)).append(this.createArticleAddToCart(article));
	      infoWrapper.append(alignBottom);
	
	      articleEl.append(infoWrapper);
	
	      return articleEl;
	    }
	  }, {
	    key: "createArticleImage",
	    value: function createArticleImage(article) {
	      var articleImage = ElementCreator.createStringElement({
	        tagName: "img",
	        attributes: [{ name: "src", value: article.image }]
	      });
	
	      var articleImageWrapper = ElementCreator.createStringElement({
	        classNames: ["article-image"],
	        innerHTML: articleImage
	      });
	
	      return articleImageWrapper;
	    }
	  }, {
	    key: "createArticleInfo",
	    value: function createArticleInfo(article) {
	      var infoEl = $("<div class='article-info'></div>");
	
	      if (!utils.isNullOrEmpty(article.title)) {
	        infoEl.append("<div class='article-title'>" + article.title + "</div>");
	      }
	
	      if (!utils.isNullOrEmpty(article.author)) {
	        infoEl.append("<div class='article-author'>" + article.author + "</div>");
	      }
	
	      if (!utils.isNullOrEmpty(article.publisher)) {
	        infoEl.append("<div class='article-publisher'>" + article.publisher + "</div>");
	      }
	
	      if (!utils.isNullOrEmpty(article.age)) {
	        infoEl.append("<div class='article-age'>" + article.age + "</div>");
	      }
	
	      if (!utils.isNullOrEmpty(article.remark)) {
	        if (article.purchasable) {
	          infoEl.append("<div class='article-remark-purchasable'>" + article.remark + "</div>");
	        }
	        /*
	        else
	        {
	          infoEl.append("<div class='article-remark-unpurchasable'>" + article.remark + "</div>");
	        }*/
	      }
	
	      // if(!utils.isNullOrEmpty(article.age))
	      // {
	      //   infoEl.append("<div class='article-age'>" + article.age + "</div>");
	      // }
	
	      return infoEl;
	    }
	  }, {
	    key: "createArticlePrice",
	    value: function createArticlePrice(article) {
	      var priceEl = ElementCreator.createStringElement({
	        classNames: ["price"],
	        innerHTML: this.catalog.currency + " " + article.priceVat
	      });
	
	      var priceExtraEl = ElementCreator.createStringElement({
	        classNames: ["vat"],
	        innerHTML: LanguageManager.getValueForKey("store.catalog.vat.inclusive") + " " + article.vatPercentage + "% " + LanguageManager.getValueForKey("store.catalog.vat")
	      });
	
	      var priceWrapperEl = ElementCreator.createStringElement({
	        classNames: ["article-price"],
	        innerHTML: priceEl + priceExtraEl
	      });
	
	      return priceWrapperEl;
	    }
	  }, {
	    key: "createArticleMoreInfo",
	    value: function createArticleMoreInfo(article) {
	      var moreInfoEl = ElementCreator.createStringElement({});
	
	      return "";
	    }
	  }, {
	    key: "createArticleAddToCart",
	    value: function createArticleAddToCart(article) {
	      var disabledClass = "";
	
	      if (!article.purchasable || article.alreadyOwned || utils.isNotNull(this.cart) && this.cart.containsArticle(article.key) && article.purchaseOnce) {
	        disabledClass = "disabled";
	      }
	
	      var addToCartLinkEl = ElementCreator.createStringElement({
	        tagName: "button",
	        classNames: ["btn", "btn-main", "no-icon", "add-article-btn", disabledClass],
	        attributes: [{ name: "data-article-key", value: article.key }, { name: "type", value: "button" }],
	        innerHTML: LanguageManager.getValueForKey("store.catalog.add_to_cart")
	      });
	
	      var addToCartWrapperEl = ElementCreator.createStringElement({
	        classNames: ["article-add"],
	        innerHTML: addToCartLinkEl
	      });
	
	      return addToCartWrapperEl;
	    }
	  }, {
	    key: "visibleArticles",
	    get: function get() {
	      return utils.isArray(this._filteredArticles) ? this._filteredArticles.length : 0;
	    }
	  }]);
	
	  return CatalogTemplate;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 609:
259,

/***/ 610:
259,

/***/ 653:
259,

/***/ 671:
/***/ (function(module, exports) {

	module.exports = "<div> <h5 class=subtitle>Digitaal jaarabonnement</h5> <p> Voor bibliotheken bieden we een digitaal abonnement voor Fundels AVI-boeken aan. Dit digitaal abonnement geeft de bibliotheek en <span class=font-montserrat-medium>bijhorende filialen</span> de mogelijkheid <span class=font-montserrat-medium>één jaar</span> (i.e. van januari tot december) Fundels AVI-boeken aan te bieden aan alle bibbezoekers. Wie intekent op een digitaal abonnement in de loop van het jaar, betaalt enkel de resterende maanden. </p> <h5 class=subtitle>Platformen</h5> <p> Fundels AVI-boeken is beschikbaar als een webbased versie voor alle internetbrowsers. Voor het optimaal functioneren wordt aangeraden de laatste versie van de browser te installeren.<br/> Fundels AVI-boeken is ook beschikbaar als applicatie voor iOS tablets.<br/> Zowel binnen de bibliotheekmuren als voor de bibbezoekers thuis zijn al deze platformen beschikbaar. </p> <h5 class=subtitle>Uitlenen</h5> <p> Bibliotheekbezoekers kunnen op basis van hun 'Mijn Bibliotheek' account Fundels AVI-boeken uitlenen. Elke account kan 7 boekjes uitlenen per jaar, die telkens 4 weken beschikbaar blijven. Heeft een bibliotheekbezoeker leden binnen het gezin gekoppeld aan zijn/haar account, dan wordt het aantal uitleningen met 7 stuks verhoogd. </p> <h5 class=subtitle>Verlenging</h5> <p> Indien de bibliotheek het volgende jaar Fundels niet langer wenst aan de bieden aan de bibbezoekers dan moet het abonnement opgezegd worden voor 10 december van dat jaar. Het abonnement opzeggen kan op MyFundels. Wordt het abonnement niet expliciet opgezegd, dan gaan we uit van een stilzwijgende verlenging. </p> </div> ";

/***/ }),

/***/ 672:
/***/ (function(module, exports) {

	module.exports = "<div> <h5 class=subtitle>Digitaal jaarabonnement</h5> <p> Voor bibliotheken bieden we een digitaal abonnement voor Fundels Prentenboeken aan. Dit digitaal abonnement geeft de bibliotheek en <span class=font-montserrat-medium>bijhorende filialen</span> de mogelijkheid <span class=font-montserrat-medium>één jaar</span> (i.e. van januari tot december) Fundels Prentenboeken aan te bieden aan alle bibbezoekers. Wie intekent op een digitaal abonnement in de loop van het jaar, betaalt enkel de resterende maanden. </p> <h5 class=subtitle>Platformen</h5> <p> Fundels Prentenboeken is beschikbaar als programma voor de vaste computer en laptop binnen een Windows omgeving.<br/> Fundels Prentenboeken is ook beschikbaar als applicatie voor mobiele toestellen. iOS en Android tablets, alsook iPhone.<br/> Zowel binnen de bibliotheekmuren als voor de bibbezoekers thuis zijn al deze platformen beschikbaar. </p> <h5 class=subtitle>Uitlenen</h5> <p> Bibliotheekbezoekers kunnen op basis van hun 'Mijn Bibliotheek' account Fundels Prentenboeken uitlenen. Elke account kan 7 boekjes uitlenen per jaar, die telkens 4 weken beschikbaar blijven. Heeft een bibliotheekbezoeker leden binnen het gezin gekoppeld aan zijn/haar account, dan wordt het aantal uitleningen met 7 stuks verhoogd. </p><h5 class=subtitle>Verlenging</h5> <p> Indien de bibliotheek het volgende jaar Fundels niet langer wenst aan de bieden aan de bibbezoekers dan moet het abonnement opgezegd worden voor 10 december van dat jaar. Het abonnement opzeggen kan op MyFundels. Wordt het abonnement niet expliciet opgezegd, dan gaan we uit van een stilzwijgende verlenging. </p> </div> ";

/***/ }),

/***/ 673:
/***/ (function(module, exports) {

	module.exports = "<div> <h5 class=subtitle>Digitaal jaarabonnement</h5> <p> Binnen de logopediepraktijk wordt gewerkt met een digitaal abonnement. Dit abonnement geeft de praktijk toegang gedurende <span class=font-montserrat-medium>één kalenderjaar</span> tot de <span class=font-montserrat-medium>volledige catalogus</span> (incl. uitbreiding van de catalogus) en het <span class=font-montserrat-medium>opvolgsysteem</span>. De kostprijs voor een digitaal abonnement bedraagt € 189,99 (incl. 21% BTW). </p> <h5 class=subtitle>Platformen</h5> <p> Fundels AVI-boeken is beschikbaar als een webbased versie voor alle internetbrowsers. Voor het optimaal functioneren wordt aangeraden de laatste versie van de browser te installeren. </p> <h5 class=subtitle>Verlenging</h5> <p> Enkele weken voor het verstrijken van geldigheidsduur van het abonnement, krijgt de contactpersoon een herinneringsmailtje om het abonnement te verlengen. Wordt niet gereageerd op deze mail, dan wordt dit aanschouwd als een stilzwijgende instemming van verlenging van het abonnement. </p> </div> ";

/***/ }),

/***/ 674:
/***/ (function(module, exports) {

	module.exports = "<div> <h5 class=subtitle>Digitaal jaarabonnement</h5> <p> Binnen de logopediepraktijk wordt gewerkt met een digitaal abonnement. Dit abonnement geeft de praktijk toegang gedurende <span class=font-montserrat-medium>één kalenderjaar</span> tot de <span class=font-montserrat-medium>volledige catalogus</span> (incl. uitbreiding van de catalogus). De kostprijs voor een digitaal abonnement bedraagt € 218.49 (incl. 21% BTW). </p> <h5 class=subtitle>Platformen</h5> <p> Fundels Prentenboeken is beschikbaar als programma voor de vaste computer en laptop binnen een Windows omgeving.<br/> Fundels Prentenboeken is ook beschikbaar als applicatie voor mobiele toestellen. iOS en Android tablets, alsook iPhone.<br/> Het abonnement geeft toegang tot alle platformen. </p> <h5 class=subtitle>Verlenging</h5> <p> Enkele weken voor het verstrijken van geldigheidsduur van het abonnement, krijgt de contactpersoon een herinneringsmailtje om het abonnement te verlengen. Wordt niet gereageerd op deze mail, dan wordt dit aanschouwd als een stilzwijgende instemming van verlenging van het abonnement. </p> </div> ";

/***/ }),

/***/ 675:
/***/ (function(module, exports) {

	module.exports = "<div> <h5 class=subtitle>Digitaal jaarabonnement</h5> <p> Binnen de kinderopvang wordt gewerkt met een digitaal abonnement. Dit abonnement geeft de opvang toegang gedurende <span class=font-montserrat-medium>één kalenderjaar</span> tot de <span class=font-montserrat-medium>volledige catalogus</span> (incl. uitbreiding van de catalogus). De kostprijs voor een digitaal abonnement bedraagt € 218.49 (incl. 21% BTW). </p> <h5 class=subtitle>Platformen</h5> <p> Fundels Prentenboeken is beschikbaar als programma voor de vaste computer en laptop binnen een Windows omgeving.<br/> Fundels Prentenboeken is ook beschikbaar als applicatie voor mobiele toestellen. iOS en Android tablets, alsook iPhone.<br/> Het abonnement geeft toegang tot alle platformen. </p> <h5 class=subtitle>Verlenging</h5> <p> Enkele weken voor het verstrijken van geldigheidsduur van het abonnement, krijgt de contactpersoon een herinneringsmailtje om het abonnement te verlengen. Wordt niet gereageerd op deze mail, dan wordt dit aanschouwd als een stilzwijgende instemming van verlenging van het abonnement. </p> </div> ";

/***/ }),

/***/ 676:
/***/ (function(module, exports) {

	module.exports = "<div> <h5 class=subtitle>Digitaal jaarabonnement</h5> <p> Voor scholen bieden we een digitaal abonnement voor Fundels AVI-boeken aan. Dit digitaal abonnement geeft de school en <span class=font-montserrat-medium>bijhorende vestigingen</span> toegang gedurende <span class=font-montserrat-medium>één kalenderjaar</span> tot de <span class=font-montserrat-medium>volledige catalogus</span> (incl. uitbreiding van de catalogus) en het <span class=font-montserrat-medium>leerlingvolgsysteem</span>. De kostprijs voor een digitaal abonnement bedraagt € 189,99 (incl. 21% BTW). </p> <h5 class=subtitle>Platformen</h5> <p> Fundels AVI-boeken is beschikbaar als app voor Windows op desktop, Mac OSX, iOS en Android tablets.<br/> In de app is enkel het lezen beschikbaar. De geplande uitbreidingen naar de spellen en de oefeningen staat even on hold. Niet getreurd er worden wel nieuwe boekjes toegevoegd (met uitzondering van de webbased versie). </p> <p> Fundels AVI-boeken is ook beschikbaar als een webbased versie voor alle internetbrowsers. Voor het optimaal functioneren wordt aangeraden de laatste versie van de browser te installeren. </p> <p> Het abonnement geeft toegang tot alle platformen. </p> <h5 class=subtitle>Groepsaankoop</h5> <p> Wens je samen met andere scholen een schoolabonnement af te sluiten, dan kan je overgaan tot een groepsaankoop. </p> <p> Voorwaarden voor een groepsaankoop: </p> <ul> <li>groepsaankoop wordt afgesloten per product</li> <li>1 factuur</li> <li>zelfde begin- en einddatum van het abonnement voor alle scholen</li> </ul> <p> Toegekende kortingspercentages: </p> <ul> <li>min. 5 scholen: 5% korting</li> <li>min. 10 scholen: 8% korting</li> <li>min. 20 scholen: 10% korting</li> <li>min. 50 scholen: 12% korting</li> </ul> <h5 class=subtitle>Verlenging</h5> <p> Enkele weken voor het verstrijken van geldigheidsduur van het abonnement, krijgt de contactpersoon een herinneringsmailtje om het abonnement te verlengen. Wordt niet gereageerd op deze mail, dan wordt dit aanschouwd als een stilzwijgende instemming van verlenging van het abonnement. </p> </div> ";

/***/ }),

/***/ 677:
/***/ (function(module, exports) {

	module.exports = "<div> <h5 class=subtitle>Digitaal jaarabonnement</h5> <p> Voor scholen bieden we een digitaal abonnement voor Fundels Prentenboeken aan. Dit digitaal abonnement geeft de school en <span class=font-montserrat-medium>bijhorende vestigingen</span> toegang gedurende <span class=font-montserrat-medium>één kalenderjaar</span> tot de <span class=font-montserrat-medium>volledige catalogus</span> (incl. uitbreiding van de catalogus). De kostprijs voor een digitaal abonnement bedraagt € 218.49 (incl. 21% BTW). </p> <h5 class=subtitle>Platformen</h5> <p> Fundels Prentenboeken is beschikbaar als app voor Windows op desktop, Mac OSX, iOS en Android tablets. </p> <p> Het abonnement geeft toegang tot alle platformen. </p> <h5 class=subtitle>Groepsaankoop</h5> <p> Wens je samen met andere scholen een schoolabonnement af te sluiten, dan kan je overgaan tot een groepsaankoop. </p> <p> Voorwaarden voor een groepsaankoop: </p> <ul> <li>groepsaankoop wordt afgesloten per product</li> <li>1 factuur</li> <li>zelfde begin- en einddatum van het abonnement voor alle scholen</li> </ul> <p> Toegekende kortingspercentages: </p> <ul> <li>min. 5 scholen: 5% korting</li> <li>min. 10 scholen: 8% korting</li> <li>min. 20 scholen: 10% korting</li> <li>min. 50 scholen: 12% korting</li> </ul> <h5 class=subtitle>Verlenging</h5> <p> Enkele weken voor het verstrijken van geldigheidsduur van het abonnement, krijgt de contactpersoon een herinneringsmailtje om het abonnement te verlengen. Wordt niet gereageerd op deze mail, dan wordt dit aanschouwd als een stilzwijgende instemming van verlenging van het abonnement. </p> </div> ";

/***/ })

});


// WEBPACK FOOTER //
// js/catalog-overview.fc98ac18e4dac765ef14.js